"use strict";

function helper(Handlebars) {
  /**
   * Convert JSON Object to String
   * var userObject = {name:'LC'};
    * {{json userObject}} --> returns "{"name":"LC"}"
   *
   * @return {String} String of the passed JSON Object
   */

  function jsonString(value) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var pretty = options.hash && options.hash.pretty === true;
    if (typeof value === 'object' && value !== null) {
      // if pretty, indent 2 spaces and wrap in <pre> tag to preserve indentation
      if (pretty) {
        return new Handlebars.SafeString("<pre>".concat(JSON.stringify(value, null, 2), "</pre>"));
      }
      return JSON.stringify(value);
    }
    return undefined;
  }
  Handlebars.registerHelper('jsonString', jsonString);
  return jsonString;
}
module.exports = helper;
